import { EventType } from '~/Models/DTO/Event.model';

export enum EventCategory {
  BABY = 'Baby',
  CLASS = 'Class',
  COURSE = 'Course',
  RETREAT = 'Retreat',
  WORKSHOP = 'Workshop',
  APPOINTMENT = 'Appointment',
  PREVENTIONS = 'Preventions',
  OPEN_SESSION = 'OpenSession',
  FREE_TRAINING = 'FreeTraining',
  COURSE_SENIORS = 'CourseSeniors',
  COURSE_CHILDREN = 'CourseChildren',
  PRENATAL_COURSE = 'PrenatalCourse',
  POSTNATAL_COURSE = 'PostnatalCourse',
  COURSE_TEACHER_TRAINING = 'CourseTeacherTraining',
}

export type EventCategoryType = EventCategory | string;

export const getEventCategoryByType = (eventType?: EventType) => {
  switch (eventType) {
    case EventType.SPECIAL_EVENT:
      return EventCategory.WORKSHOP;
    case EventType.APPOINTMENT:
      return EventCategory.APPOINTMENT;
    case EventType.OPEN_SESSION:
      return EventCategory.OPEN_SESSION;
    case EventType.FREE_TRAINING:
      return EventCategory.FREE_TRAINING;
    case EventType.CLASS:
    default:
      return EventCategory.CLASS;
  }
};
